import { coinbaseWallet } from 'wagmi/connectors';
import { extendConnector } from './utils.js';
export const createCoinbaseConnector = /*#__PURE__*/ (params) => extendConnector(coinbaseWallet(params), 'coinbaseWalletSDK', 'Coinbase Wallet');
//# sourceMappingURL=coinbase.js.map